export default class DataTableSchema
{
	id;
	name;
    label;
    type;
    columns;
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataTableSchema.js